import "./App.css";

// Components
import NavBar from "./components/navbar";
import Footer from "./components/footer";
import Chatbot from "./components/chatBot";
import ScrollUpButton from "./components/ScrollUpButton";
import UpperNavBar from "./components/UpperNavBar";

// Pages
import Home from "./pages/home_page/home_page";
import AboutUs from "./pages/about_us/about_us";
import AluminaiRegistration from "./pages/aluminai/aluminai_registration";
import Aluminai from "./pages/aluminai/aluminai";
import AlumniDirecory from "./pages/aluminai/AlumniDirectory"
import Department from "./pages/department/department";
import Degree from "./pages/degree_page/degree";
import Acadamics from "./pages/acadamics/acadamics";
import ITServices from "./pages/it_services/it_services";
import ContactUs from "./pages/contact_us/contact_us";
import ResearchAndStudentLife from "./pages/research_&_student_life/research_and_student_life";
import GalleryAndNews from "./pages/gallery_and_news/gallery_and_news";
import DgreeRegistration from "./pages/degree_page/degree_registration";
import DgreeRegistrationApply from "./pages/degree_page/degree_registration_apply";
import Careers from "./pages/careers/careers";
import StudentLife from "./pages/student_life/student_life";
import Programs from "./pages/acadamics/programs"
import LoanDetails from "./pages/acadamics/LoanDetails"
import CQAItemDetails from "./pages/acadamics/CQA"
import TrainingPatners from "./pages/acadamics/TrainingPatners";
import { Routes, Route } from "react-router-dom";

function App() {
  return (
    <div className="App">
      {/* Navbar */}
      <UpperNavBar />
      <NavBar />
      {/* Floating Social Media Icons */}
      {/* <FloatingSocialIcons /> */}
      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/aluminai" element={<Aluminai />} />
        <Route path="/alumni-directory" element={<AlumniDirecory />} />
        <Route
          path="/aluminai-registration"
          element={<AluminaiRegistration />}
        />

        <Route path="/degree-registration" element={<DgreeRegistration />} />
        <Route
          path="/degree-registration-apply"
          element={<DgreeRegistrationApply />}
        />
        <Route path="/department" element={<Department />} />
        <Route path="/degree" element={<Degree />} />
        <Route path="/acadamics" element={<Acadamics />} />
        <Route path="/it-services" element={<ITServices />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/training-patners" element={<TrainingPatners />} />
        <Route
          path="/research-and-student-life"
          element={<ResearchAndStudentLife />}
        />

        <Route path="/student-life" element={<StudentLife />} />
        
        <Route path="/gallery-and-news" element={<GalleryAndNews />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/loans" element={<LoanDetails />} />
        <Route path="/cqa" element={<CQAItemDetails />} />
      </Routes>
      <ScrollUpButton />
      {/* Footer */}
      <Footer />
      <Chatbot />
    </div>
  );
}

export default App;
